import { AUTH_API_BASE } from 'config'

import { createFetcher } from './createFetcher'

const fetcher = createFetcher({
  baseURL: AUTH_API_BASE,
})
export default fetcher
